// @flow

import React, { Component } from "react";
import { Maybe } from "ramda-fantasy";
import moment from "moment";

import { DateField } from "@quantum/ui";

import { maybeEmpty } from "../../../util";

import "./date-picker.css";

const validateDate = date =>
  maybeEmpty(date)
    .map(date => moment(date, "DD/MM/YYYY"))
    .chain(date => (date.isValid() ? Maybe.Just(date) : Maybe.Nothing()))
    .getOrElse(false);

type Props = {
  onDateChanged: Function,
  translate: Function,
};

type State = {
  date: ?string,
  editing: boolean,
};

export default class DatePicker extends Component<Props, State> {
  state = {
    date: null,
    editing: false,
  };

  getDate = () => {
    const validDate = validateDate(this.state.date);
    return validDate ? validDate.toDate() : null;
  };

  setDate = (date: *) => {
    if (!this.state.editing) this.setState({ date });
  };

  onChangeDate = (date: *) => {
    this.setState({ date }, () => {
      return Boolean(validateDate(date) || !date) && this.props.onDateChanged();
    });
  };

  onStartEditing = () => this.setState({ editing: true });

  onStopEditing = () => this.setState({ editing: false });

  render() {
    return (
      <div className="ag-input-wrapper DatePickerFilter">
        <DateField
          closeOnSelect
          closeOnTab
          className="ag-custom-component-popup"
          dateFormat="DD/MM/YYYY"
          placeholder={this.props.translate(
            "configuracaoRelatorio.periodos.placeholder"
          )}
          strictParsing
          value={this.state.date}
          onChange={this.onChangeDate}
          inputProps={{
            onFocus: this.onStartEditing,
            className: "ag-floating-filter-input",
          }}
          onBlur={this.onStopEditing}
        />
      </div>
    );
  }
}
